<script>
export default {
  name: "AppHeader",
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<template>
<div class="header">
<!--  <a href="/" class="app-logo"></a>-->

  <div class="back-button" @click="goBack">
    <div class="back-button__icon">
      <font-awesome-icon :icon="['fas', 'arrow-left']" class="header-back-btn"/>
    </div>
    <div class="back-button__caption">
      {{$t('common.buttons.back')}}
    </div>
  </div>

</div>
</template>


<style lang="scss" scoped>

.header {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  background: #7835a6;

  .app-logo {
    display: block;
    width: 25px;
    height: 25px;
    background: url("~@/assets/mobile/pp-logo-white.svg"), no-repeat, center;
    background-size: 100%;
  }

  .back-button {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 12px;
    padding-left: 10px;
    font-size: 16px;
    color: #fff;

    &__icon {
      margin-right: 12px;
    }
    &__caption {
      font-weight: 600;
      line-height: 1.31;
      letter-spacing: -0.01px;
    }
  }

}


</style>